import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Form, Button, Spinner, Alert } from 'react-bootstrap';

function Analyze() {
  const [cryptoData, setCryptoData] = useState([]);
  const [selectedCrypto, setSelectedCrypto] = useState('bitcoin'); // Initialwert
  const [loading, setLoading] = useState(false);
  const [analysisResult, setAnalysisResult] = useState(null);
  const [error, setError] = useState('');

  // Simuliere das Abrufen der Bitcoin-Daten vom Server
  useEffect(() => {
    const fetchBitcoinData = async () => {
      setLoading(true);
      setError('');
      try {
        // Hier würde normalerweise ein API-Aufruf zu deinem Backend erfolgen,
        // um die Daten aus der 'bitcoin_data'-Tabelle abzurufen.
        // Simuliere Antwortdaten:
        const mockData = [
          { timestamp: '2025-04-15', price: 60000 },
          { timestamp: '2025-04-16', price: 61000 },
          { timestamp: '2025-04-17', price: 62500 },
          { timestamp: '2025-04-18', price: 61500 },
          { timestamp: '2025-04-19', price: 63000 },
          { timestamp: '2025-04-20', price: 64000 },
          { timestamp: '2025-04-21', price: 63500 },
        ];
        setCryptoData(mockData);
        setLoading(false);
      } catch (err) {
        setError('Fehler beim Abrufen der Bitcoin-Daten.');
        setLoading(false);
        console.error(err);
      }
    };

    fetchBitcoinData();
  }, []); // Einmal ausführen beim Mounten der Komponente

  const handleCryptoChange = (event) => {
    setSelectedCrypto(event.target.value);
    // Später hier die Logik zum Abrufen von Daten für andere Kryptowährungen hinzufügen
  };

  const analyzeData = () => {
    if (!cryptoData || cryptoData.length < 2) {
      setAnalysisResult({ buyPoints: [], sellPoints: [], message: 'Nicht genügend Daten für die Analyse.' });
      return;
    }

    // Vereinfachte Analyse-Logik (Beispiel: Lokale Minima und Maxima)
    const buyPoints = [];
    const sellPoints = [];

    for (let i = 1; i < cryptoData.length - 1; i++) {
      const prevPrice = cryptoData[i - 1].price;
      const currentPrice = cryptoData[i].price;
      const nextPrice = cryptoData[i + 1].price;

      if (currentPrice < prevPrice && currentPrice < nextPrice) {
        buyPoints.push({ timestamp: cryptoData[i].timestamp, price: currentPrice });
      }

      if (currentPrice > prevPrice && currentPrice > nextPrice) {
        sellPoints.push({ timestamp: cryptoData[i].timestamp, price: currentPrice });
      }
    }

    setAnalysisResult({ buyPoints, sellPoints, message: 'Analyse abgeschlossen.' });
  };

  return (
    <Container className="mt-5">
      <Row>
        <Col md={12}>
          <Card className="shadow">
            <Card.Header>
              <h2>Kursdaten Analyse</h2>
            </Card.Header>
            <Card.Body>
              <Form.Group className="mb-3">
                <Form.Label>Währung auswählen:</Form.Label>
                <Form.Control
                  as="select"
                  value={selectedCrypto}
                  onChange={handleCryptoChange}
                >
                  <option value="bitcoin">Bitcoin (BTC)</option>
                  {/* Später weitere Optionen hier hinzufügen */}
                </Form.Control>
              </Form.Group>

              {loading ? (
                <div className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Lädt Daten...</span>
                  </Spinner>
                  <p>Lädt Kursdaten für {selectedCrypto.toUpperCase()}...</p>
                </div>
              ) : error ? (
                <Alert variant="danger">{error}</Alert>
              ) : (
                <>
                  <h3>Kursdaten für {selectedCrypto.toUpperCase()}</h3>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Datum</th>
                        <th>Kurs</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cryptoData.map(data => (
                        <tr key={data.timestamp}>
                          <td>{data.timestamp}</td>
                          <td>{data.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <Button variant="primary" onClick={analyzeData} className="mb-3">
                    Daten analysieren
                  </Button>

                  {analysisResult && (
                    <Card className="mt-3">
                      <Card.Body>
                        <Card.Title>Analyseergebnisse</Card.Title>
                        <p>{analysisResult.message}</p>
                        {analysisResult.buyPoints.length > 0 && (
                          <div>
                            <h5>Potenzielle Kaufzeitpunkte:</h5>
                            <ul>
                              {analysisResult.buyPoints.map(point => (
                                <li key={point.timestamp}>
                                  {point.timestamp}: {point.price}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                        {analysisResult.sellPoints.length > 0 && (
                          <div>
                            <h5>Potenzielle Verkaufszeitpunkte:</h5>
                            <ul>
                              {analysisResult.sellPoints.map(point => (
                                <li key={point.timestamp}>
                                  {point.timestamp}: {point.price}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                        {analysisResult.buyPoints.length === 0 && analysisResult.sellPoints.length === 0 && (
                          <p>Keine signifikanten Kauf- oder Verkaufssignale basierend auf dieser einfachen Analyse.</p>
                        )}
                      </Card.Body>
                    </Card>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Analyze;